import React from "react";
import { qhseBg, supplyFiber1 } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Fiber = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Fiber glass tubes for cementing and coring job" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("FIBERGLASS TUBES FOR DRILLING APPLICATION")}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Fiberglass tubes as cementing string pipe is designed to install cement plug. It is completed with steel or aluminum washers, which allows, if necessary, to drill without much effort and harm to the drilling tools."
              )}
            </p>
            <p className="mt-4 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Caspian Rock Solutions may supply handling tools for fiberglass tubes as cementing pipe, such as X-over, clamp, lifting cap and etc."
              )}
            </p>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("FEATURES")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>{t("Tube length - 7600 – 9200 mm")}</li>
              <li>{t("Tube ID – 60 – 108 mm")}</li>
              <li>{t("Operating temperature – from –60 up to +150")}</li>
              <li>
                {t(
                  "Equipped with steel or aluminum ends with tapered thread, it is possible to manufacture threads according to customer requirements"
                )}
              </li>
            </ul>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("ADVANTAGES")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>{t("High installation speed at any time of the year")}</li>
              <li>
                {t(
                  "Resistance to aggressive environments and formation waters"
                )}
              </li>
              <li>{t("Resistance to temperature changes")}</li>
              <li>{t("Low thermal conductivity")}</li>
              <li>{t("Water resistance 30% lower than steel pipes")}</li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src={supplyFiber1}
              alt="Fiberglass Tubes"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Fiber;
